export interface NominationWebsite {
  websiteId: number;
  nominationId: number;
  websiteURL: string;
}

export function blankNominationWebsite(): NominationWebsite {
  return {
    websiteId: 0,
    nominationId: 0,
    websiteURL: ''
  };
}

export function copyNominationWebsite(nominationWebsite: NominationWebsite): NominationWebsite {
  return {
    websiteId: nominationWebsite.websiteId,
    nominationId: nominationWebsite.nominationId,
    websiteURL: nominationWebsite.websiteURL,
  };
}
